import { render, staticRenderFns } from "./SelectToggleInput.vue?vue&type=template&id=20c58847&"
import script from "./SelectToggleInput.vue?vue&type=script&lang=js&"
export * from "./SelectToggleInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports